<template>
  <div class="coming-soon-overlay" @click.self="close">
    <div
      class="coming-soon-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="coming-soon-title"
    >
      <button type="button" class="close-btn" aria-label="Close" @click="close">
        <span></span>
        <span></span>
      </button>

      <div class="modal-content">
        <div class="icon-frame">
          <svg
            class="clock-icon"
            width="46"
            height="46"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="24"
              cy="24"
              r="18"
              stroke="currentColor"
              stroke-width="2.5"
            />
            <path
              d="M24 13V24L31 29"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="square"
              stroke-linejoin="miter"
            />
            <path
              d="M24 3V7M24 41V45M3 24H7M41 24H45"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </div>

        <h2 id="coming-soon-title" class="modal-title">COMING SOON</h2>

        <div class="accent-line"></div>

        <p class="modal-description">Selling skins is not available yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoonModal',

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.coming-soon-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;

  background: rgba(10, 7, 7, 0.85);

  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.coming-soon-modal {
  position: relative;

  width: 100%;
  max-width: 460px;

  overflow: hidden;

  background: linear-gradient(145deg, #2d2626 0%, #1b1515 55%, #130f0f 100%);

  border: 1px solid #433a3a;

  color: #fff;

  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.65), 0 0 45px rgba(205, 65, 43, 0.08);

  animation: modal-appear 0.3s ease-out;
}

.close-btn {
  position: absolute;
  top: 22px;
  right: 22px;

  z-index: 2;

  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  background: transparent;
  border: none;

  cursor: pointer;

  transition: opacity 0.2s ease;
}

.close-btn span {
  position: absolute;

  width: 18px;
  height: 2px;

  background: #969696;

  transition: background 0.2s ease;
}

.close-btn span:first-child {
  transform: rotate(45deg);
}

.close-btn span:last-child {
  transform: rotate(-45deg);
}

.close-btn:hover span {
  background: #fff;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 55px 35px 42px;

  text-align: center;
}

.icon-frame {
  width: 90px;
  height: 90px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 28px;

  background: rgba(205, 65, 43, 0.09);
  border: 1px solid rgba(205, 65, 43, 0.4);

  transform: rotate(45deg);
}

.clock-icon {
  color: #cd412b;
  transform: rotate(-45deg);
}

.eyebrow {
  margin-bottom: 8px;

  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;

  letter-spacing: 3px;

  color: #cd412b;
}

.modal-title {
  margin: 0;

  font-family: 'Bebas Neue', sans-serif;
  font-size: 54px;
  font-weight: 700;
  line-height: 1.05;

  letter-spacing: 1px;

  color: #fff;
}

.accent-line {
  width: 46px;
  height: 3px;

  margin: 22px 0;

  background: #cd412b;
}

.modal-description {
  max-width: 300px;

  margin: 0;

  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.7;

  color: #c6baba;
}

/* Main button */
.modal-button {
  min-width: 170px;

  margin-top: 30px;
  padding: 11px 24px;

  font-family: 'Bebas Neue', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  color: #fff;
  background: #cd412b;

  border: 4px solid #aa3220;
  border-radius: 0;

  cursor: pointer;

  transition: background 0.2s ease;
}

.modal-button:hover {
  background: #aa3220;
}

/* Footer */
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;

  padding: 15px 20px;

  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid #433a3a;

  font-family: 'Open Sans', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.6px;

  color: #969696;
}

.footer-dot {
  width: 6px;
  height: 6px;

  background: #cd412b;
  border-radius: 50%;
}

/* Opening animation */
@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Mobile */
@media (max-width: 480px) {
  .coming-soon-overlay {
    padding: 16px;
  }

  .modal-content {
    padding: 48px 24px 36px;
  }

  .icon-frame {
    width: 76px;
    height: 76px;
    margin-bottom: 24px;
  }

  .clock-icon {
    width: 40px;
    height: 40px;
  }

  .modal-title {
    font-size: 44px;
  }

  .modal-description {
    font-size: 14px;
  }

  .modal-button {
    width: 100%;
    max-width: 240px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .coming-soon-modal {
    animation: none;
  }
}
</style>
